import React, { useContext, useEffect, useState } from 'react'
import { basicCaseInfo, caseTypeArray, caseTypeCommonFields, caseTypeFields, netWorthDropdown, scaleOneToTenQuestions } from '../CaseFormFields';
import { locateField } from '../CaseFormFields';
import { Context } from 'Context/Context';
import RecursiveContainer from '../RecursiveContainer';
import CloseIcon from 'Components/Icons/CloseIcon';
import CaseCreatedUpload from './CaseCreatedUpload';
import CreateCaseSkeleton from './CreateCaseSkeleton';
import { STATE_SELECTION_ENABLED, DEFAULT_STATE, casesStatusUpdateApi, createCaseApi, firmMatchApi, generateGeminiSummaryApi, getAllSubscribedProfessionals, getCaseDraftApi, raiseNotificationApi, saveCaseDraftApi } from 'Constants';
import { Link } from 'react-router-dom';
import InfoIcon from 'Components/Icons/InfoIcon';
import { Checkbox } from "@material-tailwind/react";
import { GoQuestion } from "react-icons/go";
import OwnerName from './OwnerName';
import { checkIfCaseValuable, getCaseType, getNetWorth } from 'Utils';
import ScaleOneToTen from 'Components/Element/ScaleOneToTen';
import capitalize from 'capitalize';
import CreateCaseForm from './CreateCaseForm';


function CreateFormLanding({setRenderSubFormFields, setShowMoreForm}) {

    const [quickForm, setQuickForm] = useState(basicCaseInfo);
   const [showCaseText, setShowCaseText] = useState(true);
   const [errorMsg, setErrorMsg] = useState(null);
   // Which backend-flagged fields (if any) triggered the current submitError,
   // and a monotonic id bumped on every failed submit - CreateCaseForm.jsx
   // watches submitAttemptId to jump the wizard to (and highlight) the
   // earliest step containing one of them, even on a repeat failure where
   // submitErrorFields itself wouldn't otherwise change.
   const [submitErrorFields, setSubmitErrorFields] = useState([]);
   const [submitAttemptId, setSubmitAttemptId] = useState(0);
   const [isCaseValuable, setIsCaseValuable] = useState(false);

    const {userDetails, makeApiCallFunc, setShowLoading} = useContext(Context);
   
    const [formValues, setFormValues] = useState({
        "annonymous": false,
        "contactEmail" : userDetails?.email,
        "attestation" : false,
        "injuriesRate": "1",
        "economicDamagesRate": "1",
        "nonEconomicDamagesRate": "1",
        "proofRate" : "1",
        "nonEconomicFactors": [],
        "evidenceTypes": [],
        "firstName": userDetails?.firstName,
        "lastName": userDetails?.lastName
    });
    // A client gets exactly one in-progress draft (upserted server-side by
    // owner). Fetch it once on mount and, if there's anything in it, merge
    // it over the defaults above and resume from the step they left off on.
    // CreateCaseForm isn't mounted until this resolves, so its `currentStep`
    // starts correct instead of flashing step 1 and jumping.
    const [draftLoaded, setDraftLoaded] = useState(false);
    const [initialStep, setInitialStep] = useState(1);
    useEffect(() => {
        makeApiCallFunc(
            getCaseDraftApi,
            null,
            ({ data }) => {
                if (data && data.formValues && Object.keys(data.formValues).length) {
                    setFormValues((prev) => ({ ...prev, ...data.formValues }));
                    setInitialStep(data.currentStep || 1);
                }
                setDraftLoaded(true);
            },
            () => setDraftLoaded(true),
            false,
            true
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Best-effort autosave, called by CreateCaseForm whenever the wizard
    // moves to a new step (including each severity rate sub-step). File
    // inputs aren't meaningfully JSON-serializable and don't need to
    // survive a resume - they're just re-attached - so they're stripped
    // before sending.
    const saveDraft = (values, step) => {
        // continueToNext (CreateCaseForm.jsx) only calls this after
        // isFormValid confirms the step being left is OK, so a step
        // actually advancing is also the signal that whatever the last
        // failed submit flagged there (see resolveSubmitError /
        // submitAttemptId above, and the jump-to-field effect in
        // CreateCaseForm.jsx) has been fixed. Clear the banner here
        // instead of leaving it stuck up until the next full submit -
        // any OTHER still-broken field further ahead keeps its own red
        // border/FieldError regardless, since those live in `errors`,
        // not in this banner.
        if (errorMsg || submitErrorFields.length) {
            setErrorMsg(null);
            setSubmitErrorFields([]);
        }
        const draftValues = {};
        Object.entries(values || {}).forEach(([key, val]) => {
            if (val instanceof File || (typeof FileList !== "undefined" && val instanceof FileList)) return;
            draftValues[key] = val;
        });
        makeApiCallFunc(
            saveCaseDraftApi,
            { formValues: draftValues, currentStep: step },
            () => {},
            null,
            false,
            true
        );
    };
    const [createdCaseId, setCreatedCaseId] = useState(null);
    const [promptValue, setPromptValue] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [errors, setErrors] = useState({});
    const [isAnnonymous, setIsAnnonymous] = useState(false);
    const [onHover, setOnHover] = useState(false);

    const [ownerName, setOwnerName] = useState({
        firstName: userDetails?.firstName,
        lastName: userDetails?.lastName
    })

    const isFormValid = (section) => {
    let isValid = true;
    section.map((fields) => {
        if(fields.fields)
        {
            fields.fields.map((subField) =>  {
                // requiredIf covers fields that are only rendered (and thus
                // only meant to be required) once another field has a
                // specific value - e.g. the class-action triage questions in
                // AdditionalInfoFields.jsx, only shown once defendant==="yes".
                const conditionallyRequired = subField.requiredIf && formValues[subField.requiredIf.field] === subField.requiredIf.value;
                if(subField.required || conditionallyRequired)
                {
                if(subField.hideWhenAnonymous && !formValues["annonymous"] && (formValues[subField.name] === undefined || formValues[subField.name   ] === "" || formValues[subField.name   ] === null))
                {
                    setErrors((prev) => 
                    {
                        const newObj = {...prev};
                        newObj[subField.name] = subField.error;
                        return newObj;
                    })
                    isValid = false;
                }
                // Array-valued fields (checkboxGroup, e.g. evidenceTypes) are
                // "answered" once at least one option is picked - formValues
                // holds [] rather than undefined the moment a box is checked
                // and then unchecked back to none, so that needs its own
                // emptiness check alongside the generic undefined/"" one.
                const isEmptyArray = Array.isArray(formValues[subField.name]) && formValues[subField.name].length === 0;
                if( !subField.doNotShow && (!Object.entries(formValues).length || formValues[subField.name] === undefined || formValues[subField.name]?.value === "" || isEmptyArray))
                {
                    setErrors((prev) => 
                    {
                        const newObj = {...prev};
                        newObj[subField.name] = subField.error
                        return newObj;
                    });
                    isValid = false;
                }
            }
        });
        }
    });
    // if(!formValues.attestation)
    // {
    //     setErrors((prev) => 
    //     {
    //         const newObj = {...prev};
    //         newObj["attestation"] = "You must agree to this statement to proceed.";
    //         return newObj;
    //     });
    //     isValid = false;
    // }
    return isValid;
    }
    const onChangeUpdate = (e, individualConfig) => 
    {
        console.log("on change update triggered with ", e, individualConfig)
    const {name, type, label, error, valueTxt} = individualConfig;
    let value;
    switch(type)
    {
        case "date":
            value = e;
            if(value === null)
            {
                setErrors((prev) => 
                    {
                        const newObj = {...prev};
                        newObj[name] = error
                        return newObj;
                    })
            }
            else
            {
                setErrors((prev) => 
                    {
                        const newObj = {...prev};
                        delete newObj[name];
                        return newObj;
                    })
            }
            break;
        case "fileUpload":
            value= e.currentTarget.files;
            break;
        case "anonymousCheckbox":
            value = e.target.checked;
            if(value)
            {
                setFormValues((prev) => {
                    const newVal = {...prev};
                    newVal["firstName"] = null;
                    newVal["lastName"] = null;
                    return newVal;
                });
            }
            console.log("checkbox value of ", individualConfig.name, " is ", value)
            break;
        case "scale":
            value = valueTxt;
            break;
        case "checkboxGroup":
            // RecursiveContainer already computes the full next array (see
            // its checkboxGroup case) and passes it straight through as `e`,
            // same pattern as "date" above.
            value = e;
            break;
        case "number":
            value = e.target.value.replace(/\D/g, '');
            break; 
        case 'input':
            value = (name === "clientZipcode" || name === "caseZipcode")
                ? e.target.value.replace(/[^\d-]/g, '').slice(0, 10)
                : capitalize.words(e.target.value);
            break;
        case "checkbox":
        case "sameLocationCheckbox":
            value = e.target.checked;
            break;

        case "select":
        default:
            value = e.target.value;
            break;
    }
    
    setFormValues((prev) => {
        const newVal = {...prev}
        newVal[name] = value;
        return newVal;
    });

    if(individualConfig.name === "caseType")
    {
        //const subObject = caseTypeFields[e.target.value];
        const subObject = caseTypeCommonFields;
        setRenderSubFormFields(subObject);
        console.log(subObject)
    }

    // "This happened at the same location I'm located" (CaseLocationSameCheckbox.jsx,
    // step 2) mirrors the client's own city/state/zipcode into
    // caseCity/caseState/caseZipcode whenever caseLocationSame is checked
    // (the default). That mirroring previously only ran from an effect
    // inside that component, which is unmounted while the user is on step 1
    // - so editing your own zipcode there, then coming back, could leave
    // the case location stale. Doing it centrally here instead means it
    // updates the moment the client field itself changes, regardless of
    // which step is currently showing.
    const CLIENT_TO_CASE_LOCATION_FIELD = { clientCity: "caseCity", clientState: "caseState", clientZipcode: "caseZipcode" };
    if (CLIENT_TO_CASE_LOCATION_FIELD[name] && formValues.caseLocationSame !== false) {
        const caseFieldName = CLIENT_TO_CASE_LOCATION_FIELD[name];
        setFormValues((prev) => ({ ...prev, [caseFieldName]: value }));
    }

    // classActionCommonCause/arbitrationClause (AdditionalInfoFields.jsx)
    // only apply, and are only shown, once defendant === "yes" - switching
    // back to "Just me" needs to actively drop any answer already given to
    // them (and any error still shown for them), not just stop rendering
    // the questions, otherwise a stale answer from before the switch would
    // still show on the Review step and still get submitted.
    if (individualConfig.name === "defendant" && value !== "yes") {
        setFormValues((prev) => {
            const newVal = {...prev};
            delete newVal.classActionCommonCause;
            delete newVal.arbitrationClause;
            return newVal;
        });
        setErrors((prev) => {
            const newObj = {...prev};
            delete newObj.classActionCommonCause;
            delete newObj.arbitrationClause;
            return newObj;
        });
    }
    console.log(formValues)
    }
    const onBlurValidate = (e, individualConfig) => {
    const {required, requiredIf, name, error, type} = individualConfig;
    const isRequired = required || (requiredIf && formValues[requiredIf.field] === requiredIf.value);
    console.log("triggered", individualConfig)
    if(individualConfig.length && e.target.value.length !== individualConfig.length)
    {
        console.log("length error", individualConfig.length, e.target.value.length)
        setErrors((prev) => 
        {
            const newObj = {...prev};
            newObj[name] = `${individualConfig.label} should have ${individualConfig.length} digits`;
            return newObj;
        })
        return;
    }
    if((name === "clientZipcode" || name === "caseZipcode") && e.target.value && !/^\d{5}(-\d{4})?$/.test(e.target.value))
    {
        setErrors((prev) => 
        {
            const newObj = {...prev};
            newObj[name] = "Enter a valid 5-digit zipcode";
            return newObj;
        })
        return;
    }
    if(isRequired)
    {

    if((type === "date" && e === "") || (type !== "date" && e.target.value === ""))
    {
        setErrors((prev) => 
        {
            const newObj = {...prev};
            newObj[name] = error
            return newObj;
        })
    }
    else
    {

        setErrors((prev) => 
        {
        const newObj = {...prev};
        delete newObj[name];
        return newObj;
        })
    }
    }
    }   
    // The severity step (design's "Severity rate" screen) collects plain-
    // language answers instead of a raw 1-10 slider. injuriesRate /
    // economicDamagesRate / nonEconomicDamagesRate / proofRate still get
    // submitted (caseValuationPrompt.js and account.js both read them), so
    // we derive a representative 1-10 number from the descriptive answers
    // right before submit rather than asking the user to pick a number.
    const INJURY_SEVERITY_RATE = { minor: 2, moderate: 5, severe: 8, lifeAltering: 10 };
    // current ranges (CaseFormFields.js) + the old ones, so drafts saved before the change still score
    const MEDICAL_BILLS_RATE = {
        under10k: 3, "10kTo100k": 6, "100kTo500k": 8, over500k: 10, notSure: 5,
        under1k: 2, "1kTo10k": 4, "10kTo50k": 6, "50kTo100k": 8, over100k: 10,
    };
    const DAY_TO_DAY_RATE = { minimal: 2, some: 5, significant: 8, severe: 10 };
    const deriveSeverityRates = (values) => ({
        injuriesRate: INJURY_SEVERITY_RATE[values.injuriesSeverity] || 1,
        economicDamagesRate: MEDICAL_BILLS_RATE[values.medicalBillsRange] || 1,
        nonEconomicDamagesRate: DAY_TO_DAY_RATE[values.dayToDayImpact] || 1,
        proofRate: Math.max(1, Math.min(10, Math.round(((values.evidenceTypes?.length || 0) / 6) * 10))),
    });
    // The design's "Additional information" step only asks 3 questions
    // (isPostedBySelf, defendant, isEntity) — isClassAction, adversePartyNetWorth,
    // and adversePartyPublicCompany aren't asked anymore, but the backend
    // (createCaseSchema.js) still requires them and attorney-side filtering/
    // valuation (caseValuationPrompt.js, case.js) still reads them, so we
    // derive reasonable values from what IS asked rather than dropping the
    // fields from the DB.
    const ENTITY_NET_WORTH_DEFAULT = { yes: 2, no: 1 }; // company vs individual, netWorthDropdown id
    // isClassAction used to just mirror "do you know of others" (defendant),
    // which only signals numerosity. classActionCommonCause/arbitrationClause
    // (asked in AdditionalInfoFields.jsx, only when defendant === "yes") add
    // the two factors that actually distinguish a class-action candidate:
    // whether the harm traces to something shared rather than the user's own
    // situation, and whether a known arbitration/class-waiver clause would
    // likely rule a class action out regardless of the rest. This is still a
    // triage flag for attorney-side filtering, not a legal determination -
    // an unanswered common-cause question falls back to the old numerosity-
    // only behavior so we don't regress cases that skip it.
    const derivePartyDetails = (values) => {
        let isClassAction = "no";
        if (values.defendant === "yes") {
            if (values.arbitrationClause === "yes") {
                isClassAction = "no";
            } else if (values.classActionCommonCause === "no") {
                isClassAction = "no";
            } else {
                isClassAction = "yes";
            }
        }
        return {
            isClassAction,
            adversePartyPublicCompany: "no",
            adversePartyNetWorth: ENTITY_NET_WORTH_DEFAULT[values.isEntity] || 1,
        };
    };
    // The backend (server/routes/case.js createCase) responds to a failed
    // validation with { message: "Validation failed", errors: { fieldName:
    // ["actual reason"] } } - the field-level messages are the useful part
    // (e.g. "Phone must be exactly 10 digits"), but only the generic
    // top-level message was ever shown. Surface the real reason(s) instead,
    // falling back to the generic message for errors that aren't shaped
    // like a validation failure (network error, 500, etc.).
    // Field-level messages that map to a real, currently-navigable wizard
    // field (e.g. caseZipcode) are shown right under that input instead -
    // same red border + FieldError treatment every other field error
    // already gets (see RecursiveContainer.jsx) - and the wizard jumps to
    // whichever step has the earliest one (below). Only messages that
    // can't be pinned to a visible field - a genuinely generic failure, or
    // a validation key that isn't part of the wizard's own fields - still
    // go in the page-level banner.
    const resolveSubmitError = (responseData) => {
        const fieldErrors = responseData?.errors;
        const mapped = {};
        const unmapped = [];
        if (fieldErrors && typeof fieldErrors === "object") {
            Object.entries(fieldErrors).forEach(([key, val]) => {
                const msg = Array.isArray(val) ? val[0] : val;
                if (!msg) return;
                if (locateField(key)) mapped[key] = msg;
                else unmapped.push(msg);
            });
        }
        let banner;
        if (unmapped.length) {
            banner = unmapped.join(" ");
        } else if (Object.keys(mapped).length) {
            banner = `Please fix the highlighted field${Object.keys(mapped).length > 1 ? "s" : ""} below.`;
        } else {
            banner = responseData?.message || "Something went wrong submitting your case. Please try again.";
        }
        return { banner, mapped };
    };
    const onSubmit = () => {
        window.scrollTo(0,0)
        setErrorMsg(null);
        const submissionValues = { ...formValues, ...deriveSeverityRates(formValues), ...derivePartyDetails(formValues),
            // Texas-only launch: no state question in the form
            ...(STATE_SELECTION_ENABLED ? {} : { caseState: DEFAULT_STATE, clientState: DEFAULT_STATE }) };
        // Safety net alongside the onChangeUpdate clear above - covers a
        // draft saved before this switch-back-to-"no" clearing existed, or
        // any other path that left a stale answer sitting in formValues.
        // classActionCommonCause/arbitrationClause should never reach the
        // backend for a case that isn't a class-action candidate.
        if (submissionValues.defendant !== "yes") {
            delete submissionValues.classActionCommonCause;
            delete submissionValues.arbitrationClause;
        }
        const formData = new FormData();
        Object.entries(submissionValues).map((data)=>{
            const [key, val] = data;
            formData.append(key, Array.isArray(val) ? JSON.stringify(val) : val);
        })
        console.log("Form values to be sent", submissionValues);
        makeApiCallFunc(createCaseApi, 
            formData, 
        successCallback,
        (data) => {
            // Page-level fallback shown via FormErrorBanner (CreateCaseForm
            // renders it at the top of the Review & Submit step, below the
            // step header - same treatment as Signup.jsx's apiError) rather
            // than a toast, since this needs to stay visible while the user
            // reviews what to fix, not disappear after a few seconds.
            // Field-level messages that map to a real wizard field are
            // merged into `errors` instead, so the field itself gets
            // highlighted - see resolveSubmitError above.
            const { banner, mapped } = resolveSubmitError(data?.response?.data);
            setErrorMsg(banner);
            if (Object.keys(mapped).length) {
                setErrors((prev) => ({ ...prev, ...mapped }));
                setSubmitErrorFields(Object.keys(mapped));
                setSubmitAttemptId((id) => id + 1);
            }
            console.log("data displaying", data?.response)
            console.log(data)},
        true)
        console.log("Form data to be sent", formData);
        
    }
    const generateGeminiSummary = function ({
        caseId
    })
    {
        // Research -> valuation only now. Firm-match is fired as its own
        // separate call below (runFirmMatch) instead of being chained after
        // this one, so the case detail page can show firm matches as soon
        // as they're ready without waiting on research/valuation to finish
        // too (see server/routes/case.js - /generateGeminiSummary no longer
        // triggers firm-match internally).
        makeApiCallFunc(generateGeminiSummaryApi,
            {
                caseId: caseId,
            },
            (response) => {
                console.log("Gemini response for prompt:", response);

            },
            (error) => {
                console.error("Error fetching Gemini summary:", error);
            },
            null,
            true
        )
    }
    const runFirmMatch = function ({
        caseId
    })
    {
        makeApiCallFunc(firmMatchApi.replace(':caseId', caseId),
            {},
            (response) => {
                console.log("Firm match response:", response);
            },
            (error) => {
                console.error("Error fetching firm match:", error);
            },
            null,
            true
        )
    }
    const successCallback = ({data}) => {

         // Fired together, not one after the other - see the comments on
         // generateGeminiSummary/runFirmMatch above.
         generateGeminiSummary({
            caseId: data._id
        })
         runFirmMatch({
            caseId: data._id
        })
        setCreatedCaseId(data._id);
        notifyFunderOfValuableCase(data)
        setShowModal(true);
    }
    const notifyFunderOfValuableCase = (caseData) => {
    console.log("Notifying funder of valuable case:", caseData);
    console.log("Is case valuable?", checkIfCaseValuable(caseData));
    if (checkIfCaseValuable(caseData)) {
         const notificationObj = {
           sendToAll: {
            role: "funder",
            sendToAll: true
        },
            title : "New Valuable Case Created",
            is_read : false,
            sender: "admin",
            notificationCategory: 1,
            caseNumber: caseData?.caseNumber,
            type: "3",
            receiver:  null,
            additionalInfo: {
                caseId: caseData?._id
            },
            content: "A new valuable case has been created that matches your funding criteria. Please review the case details and request to view more."
        }
        // Notify the funder about the valuable case
         makeApiCallFunc(raiseNotificationApi, 
                            notificationObj, 
                            (data) => console.log(data),
                            (error) => console.log(error)
                            )
    }
}
const onChange = (e) => {
console.log(e.target)
}
  return (
            <>
               
              <div className='col-span-6'>
                {!draftLoaded ? <CreateCaseSkeleton/> : (
                <CreateCaseForm errors={errors} 
                onChangeUpdate = {onChangeUpdate}
                onBlurValidate={onBlurValidate}
                isFormValid = {isFormValid}
                formValues = {formValues}
                onSubmit={onSubmit}
                initialStep={initialStep}
                saveDraft={saveDraft}
                submitError={errorMsg}
                submitErrorFields={submitErrorFields}
                submitAttemptId={submitAttemptId}
                />
                )}
                </div>
                {/* case published: two-step "add documents / video" popup (replaces the old one) */}
                {showModal && createdCaseId && <CaseCreatedUpload caseId={createdCaseId}/>}

            </>
            
  )
}

export default CreateFormLanding